module.exports = require('scryptsy')



// WEBPACK FOOTER //
// ./node_modules/web3/packages/web3-eth-accounts/node_modules/scrypt.js/js.js